import { getToken } from '@helpscout/hsds-tokens/getToken'
import { css } from 'styled-components'

export const shadow50 = css`
  box-shadow: ${getToken('shadow.50')};
`

export const shadowInverted50 = css`
  box-shadow: ${getToken('shadow.inverted.50')};
`

export const shadow100 = css`
  box-shadow: ${getToken('shadow.100')};
`

export const shadow200 = css`
  box-shadow: ${getToken('shadow.200')};
`

export const shadow400 = css`
  box-shadow: ${getToken('shadow.400')};
`

export const shadow500 = css`
  box-shadow: ${getToken('shadow.500')};
`

export const shadow700 = css`
  box-shadow: ${getToken('shadow.700')};
`
